// Textos propis de la pàgina "restaurante" per idioma (Restaurante.jsx).

const textos = {
    es: {
        heroImageAlt: "Restaurante del Hotel Camprodon",
        heroSmallTitle: "Disfruta de una cocina tradicional y de proximidad",
        heroTitle: "Restaurante del Hotel Camprodon",
        presentationSmallTitle: "Comida tradicional y de proximidad",
        presentationTitle: "Restaurante Hotel Camprodon",
        presentationContent: <>{"El Restaurant del Hotel Camprodon ofrece "}<strong>cocina casera y tradicional catalana</strong>. Trabajamos principalmente con productos de proximidad, del valle de Camprodón, así como productos de temporada.</>,
        fullSliderImgAlt: "Restaurante Hotel Camprodon",
        fullSliderImgAlt2: "Restaurante Hotel Camprodon",
        fullSliderImgAlt3: "Restaurante Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurante Hotel Camprodon",
        cardTitle: "Especialización gastronómica",
        cardContent: "Ofrecemos menús de mediodía y cena, y especialmente pensando en las familias y los más pequeños, ¡tenemos un menú infantil que les encantará!",
        cardContent2: "Algunos de nuestros platos estrella, y los que nuestros comensales más aprecian son las ensaladas con embutidos del valle, los canalones, la paella de arroz, los rustidos de ternera y el bacalao.",
        sliderControlsAboveAlt2: "Restaurante Hotel Camprodon",
        cardTitle2: "El restaurante",
        cardContent3: "El Restaurante está situado en una de nuestras salas nobles del Hotel Camprodon, y tiene capacidad hasta 140 personas. El hotel también cuenta con un segundo comedor con capacidad hasta 250 personas.",
        cardContent4: "En la primavera y en verano, podrás comer en la terraza, con vistas privilegiadas sobre el Pont Nou y el río Ter.",
        formFormValue: "es",
        checkboxHref: "/politica-de-privacidad",
        sectionHeadSubtitle: "Galería de imágenes",
        sectionHeadTitle: "Descubre el estilo modernista de nuestro restaurante",
        sectionHeadTexts: "A continuación te mostramos una galería de imágenes de nuestro restaurante, donde encontrarás una cocina tradicional, casera y de proximidad.",
        galleryItemAlt: "Restaurante Hotel Camprodon",
        galleryItemAlt2: "Restaurante Hotel Camprodon",
        galleryItemAlt3: "Restaurante Hotel Camprodon",
        galleryItemAlt4: "Restaurante Hotel Camprodon",
        galleryItemAlt5: "Restaurante Hotel Camprodon",
    },
    ca: {
        heroImageAlt: "Restaurant de l'Hotel Camprodon",
        heroSmallTitle: "Gaudeix d'una cuina tradicional i de proximitat",
        heroTitle: "Restaurant de l'Hotel Camprodon",
        presentationSmallTitle: "Menjar tradicional i de proximitat",
        presentationTitle: "Restaurant Hotel Camprodon",
        presentationContent: <>{"El Restaurant de l’Hotel Camprodon ofereix "}<strong>cuina casolana i tradicional catalana</strong>. Treballem principalment el producte de proximitat, de la vall de Camprodon, així com els productes de temporada.</>,
        fullSliderImgAlt: "Restaurant Hotel Camprodon",
        fullSliderImgAlt2: "Restaurant Hotel Camprodon",
        fullSliderImgAlt3: "Restaurant Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurant Hotel Camprodon",
        cardTitle: "Especialització gastronòmica",
        cardContent: "Oferim menú de dinar i de sopar, i especialment pensant en les famílies i en els més petits, tenim un menú per nens que els encantarà!",
        cardContent2: "Alguns dels nostres plats estrella, i els que els nostres comensals més aprecien són l’amanida amb embotits de la vall, els canelons, la paella d’arròs, el rostit de vedella amb bolets i el bacallà.",
        sliderControlsAboveAlt2: "Restaurant Hotel Camprodon",
        cardTitle2: "El restaurant",
        cardContent3: "El Restaurant està situat en una de les sales nobles de l’Hotel Camprodon, i té capacitat fins a 140 persones. L’hotel també compta amb un segon menjador amb capacitat fins a 250 persones.",
        cardContent4: "A la primavera i a l’estiu, podràs dinar a la terrassa, amb vistes privilegiades sobre el Pont Nou i el riu Ter.",
        formFormValue: "ca",
        checkboxHref: "/ca/politica-de-privacitat",
        sectionHeadSubtitle: "Galeria d'imatges",
        sectionHeadTitle: "Descobriu l'estil modernista del nostre restaurant",
        sectionHeadTexts: "A continuació us mostrem una galeria d'imatges del nostre restaurant, on trobareu una cuina tradicional, casolana i de proximitat.",
        galleryItemAlt: "Restaurant Hotel Camprodon",
        galleryItemAlt2: "Restaurant Hotel Camprodon",
        galleryItemAlt3: "Restaurant Hotel Camprodon",
        galleryItemAlt4: "Restaurant Hotel Camprodon",
        galleryItemAlt5: "Restaurant Hotel Camprodon",
    },
    en: {
        heroImageAlt: "Restaurant of Hotel Camprodon",
        heroSmallTitle: "Enjoy traditional and local cuisine",
        heroTitle: "Restaurant of Hotel Camprodon",
        presentationSmallTitle: "Traditional and local food",
        presentationTitle: "Restaurant Hotel Camprodon",
        presentationContent: <>{"Hotel Camprodon’s restaurant offers "}<strong>homemade traditional Catalan cuisine</strong>. We mainly work with local and seasonal products from Camprodon Valley.</>,
        fullSliderImgAlt: "Restaurant Hotel Camprodon",
        fullSliderImgAlt2: "Restaurant Hotel Camprodon",
        fullSliderImgAlt3: "Restaurant Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurant Hotel Camprodon",
        cardTitle: "Specialized cuisine",
        cardContent: "We offer a lunch and a dinner menu. There is also a kids menu available for children –we are confident families will love our menus!",
        cardContent2: "Some of our most popular dishes, and those our guests appreciate most, are the salad with sausages from the valley, our cannelloni, paella rice, roast veal with mushrooms and our cod.",
        sliderControlsAboveAlt2: "Restaurant Hotel Camprodon",
        cardTitle2: "The restaurant",
        cardContent3: "The restaurant is located in one of the main halls in Hotel Camprodon, and can accommodate up to 140 people. The hotel also features a second dining room for up to 250 people.",
        cardContent4: "In spring and summer you can eat out on the terrace, with spectacular views over the Pont Nou (new bridge) and the river Ter.",
        formFormValue: "en",
        checkboxHref: "/en/privacy-policy",
        sectionHeadSubtitle: "Image gallery",
        sectionHeadTitle: "Discover the modernist style of our restaurant",
        sectionHeadTexts: "Below we show you a gallery of images of our restaurant, where you will find traditional, homemade and local cuisine.",
        galleryItemAlt: "Restaurant Hotel Camprodon",
        galleryItemAlt2: "Restaurant Hotel Camprodon",
        galleryItemAlt3: "Restaurant Hotel Camprodon",
        galleryItemAlt4: "Restaurant Hotel Camprodon",
        galleryItemAlt5: "Restaurant Hotel Camprodon",
    },
    fr: {
        heroImageAlt: "Restaurant de l'Hotel Camprodon",
        heroSmallTitle: "Savourez une cuisine traditionnelle et de proximité",
        heroTitle: "Restaurant de l'Hotel Camprodon",
        presentationSmallTitle: "Cuisine traditionnelle et de proximité",
        presentationTitle: "Restaurant Hotel Camprodon",
        presentationContent: <>{"Le restaurant de l'Hotel Camprodon propose une "}<strong>cuisine maison et traditionnelle catalane</strong>. Nous travaillons principalement avec des produits de proximité, de la vallée de Camprodon, ainsi qu'avec des produits de saison.</>,
        fullSliderImgAlt: "Restaurant Hotel Camprodon",
        fullSliderImgAlt2: "Restaurant Hotel Camprodon",
        fullSliderImgAlt3: "Restaurant Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurant Hotel Camprodon",
        cardTitle: "Spécialités gastronomiques",
        cardContent: "Nous proposons des menus le midi et le soir et, en pensant spécialement aux familles et aux plus petits, nous avons un menu enfant qu'ils adoreront !",
        cardContent2: "Parmi nos plats phares, et les plus appréciés de nos convives, figurent les salades à la charcuterie de la vallée, les cannellonis, la paella, les rôtis de veau et la morue.",
        sliderControlsAboveAlt2: "Restaurant Hotel Camprodon",
        cardTitle2: "Le restaurant",
        cardContent3: "Le restaurant est situé dans l'une des salles nobles de l'Hotel Camprodon et peut accueillir jusqu'à 140 personnes. L'hôtel dispose aussi d'une seconde salle à manger d'une capacité de 250 personnes.",
        cardContent4: "Au printemps et en été, vous pourrez manger sur la terrasse, avec une vue privilégiée sur le Pont Nou et le Ter.",
        formFormValue: "fr",
        checkboxHref: "/fr/politique-de-confidentialite",
        sectionHeadSubtitle: "Galerie d'images",
        sectionHeadTitle: "Découvrez le style moderniste de notre restaurant",
        sectionHeadTexts: "Voici une galerie d'images de notre restaurant, où vous trouverez une cuisine traditionnelle, maison et de proximité.",
        galleryItemAlt: "Restaurant Hotel Camprodon",
        galleryItemAlt2: "Restaurant Hotel Camprodon",
        galleryItemAlt3: "Restaurant Hotel Camprodon",
        galleryItemAlt4: "Restaurant Hotel Camprodon",
        galleryItemAlt5: "Restaurant Hotel Camprodon",
    },
    de: {
        heroImageAlt: "Restaurant des Hotel Camprodon",
        heroSmallTitle: "Genießen Sie traditionelle und regionale Küche",
        heroTitle: "Restaurant des Hotel Camprodon",
        presentationSmallTitle: "Traditionelle und regionale Küche",
        presentationTitle: "Restaurant Hotel Camprodon",
        presentationContent: <>{"Das Restaurant des Hotel Camprodon bietet "}<strong>hausgemachte und traditionelle katalanische Küche</strong>. Wir arbeiten vor allem mit regionalen Produkten aus dem Camprodon-Tal und mit saisonalen Zutaten.</>,
        fullSliderImgAlt: "Restaurant Hotel Camprodon",
        fullSliderImgAlt2: "Restaurant Hotel Camprodon",
        fullSliderImgAlt3: "Restaurant Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurant Hotel Camprodon",
        cardTitle: "Kulinarische Spezialitäten",
        cardContent: "Wir bieten Mittags- und Abendmenüs, und besonders für Familien und die Kleinsten haben wir ein Kindermenü, das sie lieben werden!",
        cardContent2: "Zu unseren Spezialitäten, die unsere Gäste am meisten schätzen, gehören Salate mit Wurst aus dem Tal, Cannelloni, Paella, Kalbsbraten und Stockfisch.",
        sliderControlsAboveAlt2: "Restaurant Hotel Camprodon",
        cardTitle2: "Das Restaurant",
        cardContent3: "Das Restaurant befindet sich in einem der historischen Säle des Hotel Camprodon und bietet Platz für bis zu 140 Personen. Das Hotel verfügt außerdem über einen zweiten Speisesaal für bis zu 250 Personen.",
        cardContent4: "Im Frühling und Sommer können Sie auf der Terrasse essen – mit einem herrlichen Blick auf die Pont Nou und den Fluss Ter.",
        formFormValue: "de",
        checkboxHref: "/de/privacy-policy",
        sectionHeadSubtitle: "Bildergalerie",
        sectionHeadTitle: "Entdecken Sie den Jugendstil unseres Restaurants",
        sectionHeadTexts: "Hier zeigen wir Ihnen eine Bildergalerie unseres Restaurants mit traditioneller, hausgemachter und regionaler Küche.",
        galleryItemAlt: "Restaurant Hotel Camprodon",
        galleryItemAlt2: "Restaurant Hotel Camprodon",
        galleryItemAlt3: "Restaurant Hotel Camprodon",
        galleryItemAlt4: "Restaurant Hotel Camprodon",
        galleryItemAlt5: "Restaurant Hotel Camprodon",
    },
    it: {
        heroImageAlt: "Ristorante dell'Hotel Camprodon",
        heroSmallTitle: "Gusta una cucina tradizionale e a km zero",
        heroTitle: "Ristorante dell'Hotel Camprodon",
        presentationSmallTitle: "Cucina tradizionale e a km zero",
        presentationTitle: "Ristorante Hotel Camprodon",
        presentationContent: <>{"Il ristorante dell'Hotel Camprodon offre una "}<strong>cucina casalinga e tradizionale catalana</strong>. Lavoriamo principalmente con prodotti a km zero, della Valle di Camprodon, e con prodotti di stagione.</>,
        fullSliderImgAlt: "Ristorante Hotel Camprodon",
        fullSliderImgAlt2: "Ristorante Hotel Camprodon",
        fullSliderImgAlt3: "Ristorante Hotel Camprodon",
        sliderControlsAboveAlt: "Ristorante Hotel Camprodon",
        cardTitle: "Specialità gastronomiche",
        cardContent: "Offriamo menù a pranzo e a cena e, pensando soprattutto alle famiglie e ai più piccoli, abbiamo un menù per bambini che adoreranno!",
        cardContent2: "Alcuni dei nostri piatti forti, e i più apprezzati dai nostri commensali, sono le insalate con salumi della valle, i cannelloni, la paella, gli arrosti di vitello e il baccalà.",
        sliderControlsAboveAlt2: "Ristorante Hotel Camprodon",
        cardTitle2: "Il ristorante",
        cardContent3: "Il ristorante si trova in una delle sale nobili dell'Hotel Camprodon e ha una capienza fino a 140 persone. L'hotel dispone anche di una seconda sala da pranzo con capienza fino a 250 persone.",
        cardContent4: "In primavera e in estate potrai mangiare in terrazza, con una vista privilegiata sul Pont Nou e sul fiume Ter.",
        formFormValue: "it",
        checkboxHref: "/it/informativa-sulla-privacy",
        sectionHeadSubtitle: "Galleria di immagini",
        sectionHeadTitle: "Scopri lo stile modernista del nostro ristorante",
        sectionHeadTexts: "Ecco una galleria di immagini del nostro ristorante, dove troverai una cucina tradizionale, casalinga e a km zero.",
        galleryItemAlt: "Ristorante Hotel Camprodon",
        galleryItemAlt2: "Ristorante Hotel Camprodon",
        galleryItemAlt3: "Ristorante Hotel Camprodon",
        galleryItemAlt4: "Ristorante Hotel Camprodon",
        galleryItemAlt5: "Ristorante Hotel Camprodon",
    },
    pt: {
        heroImageAlt: "Restaurante do Hotel Camprodon",
        heroSmallTitle: "Desfrute de uma cozinha tradicional e de proximidade",
        heroTitle: "Restaurante do Hotel Camprodon",
        presentationSmallTitle: "Comida tradicional e de proximidade",
        presentationTitle: "Restaurante Hotel Camprodon",
        presentationContent: <>{"O restaurante do Hotel Camprodon oferece "}<strong>cozinha caseira e tradicional catalã</strong>. Trabalhamos principalmente com produtos de proximidade, do Vale de Camprodon, e com produtos da época.</>,
        fullSliderImgAlt: "Restaurante Hotel Camprodon",
        fullSliderImgAlt2: "Restaurante Hotel Camprodon",
        fullSliderImgAlt3: "Restaurante Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurante Hotel Camprodon",
        cardTitle: "Especialidades gastronómicas",
        cardContent: "Oferecemos menus ao almoço e ao jantar e, a pensar sobretudo nas famílias e nos mais pequenos, temos um menu infantil de que vão adorar!",
        cardContent2: "Alguns dos nossos pratos estrela, e os mais apreciados pelos nossos clientes, são as saladas com enchidos do vale, os canelones, a paella, os assados de vitela e o bacalhau.",
        sliderControlsAboveAlt2: "Restaurante Hotel Camprodon",
        cardTitle2: "O restaurante",
        cardContent3: "O restaurante está situado numa das salas nobres do Hotel Camprodon e tem capacidade até 140 pessoas. O hotel dispõe também de uma segunda sala de jantar com capacidade até 250 pessoas.",
        cardContent4: "Na primavera e no verão, poderá comer no terraço, com vistas privilegiadas sobre a Pont Nou e o rio Ter.",
        formFormValue: "pt",
        checkboxHref: "/pt/politica-de-privacidade",
        sectionHeadSubtitle: "Galeria de imagens",
        sectionHeadTitle: "Descubra o estilo modernista do nosso restaurante",
        sectionHeadTexts: "Mostramos-lhe a seguir uma galeria de imagens do nosso restaurante, onde encontrará uma cozinha tradicional, caseira e de proximidade.",
        galleryItemAlt: "Restaurante Hotel Camprodon",
        galleryItemAlt2: "Restaurante Hotel Camprodon",
        galleryItemAlt3: "Restaurante Hotel Camprodon",
        galleryItemAlt4: "Restaurante Hotel Camprodon",
        galleryItemAlt5: "Restaurante Hotel Camprodon",
    },
    nl: {
        heroImageAlt: "Restaurant van Hotel Camprodon",
        heroSmallTitle: "Geniet van een traditionele en lokale keuken",
        heroTitle: "Restaurant van Hotel Camprodon",
        presentationSmallTitle: "Traditionele en lokale keuken",
        presentationTitle: "Restaurant Hotel Camprodon",
        presentationContent: <>{"Het restaurant van Hotel Camprodon biedt "}<strong>huisgemaakte en traditionele Catalaanse keuken</strong>. We werken vooral met lokale producten uit de Camprodonvallei en met seizoensproducten.</>,
        fullSliderImgAlt: "Restaurant Hotel Camprodon",
        fullSliderImgAlt2: "Restaurant Hotel Camprodon",
        fullSliderImgAlt3: "Restaurant Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurant Hotel Camprodon",
        cardTitle: "Culinaire specialiteiten",
        cardContent: "We bieden lunch- en dinermenu's, en speciaal voor gezinnen en de kleintjes hebben we een kindermenu waar ze dol op zullen zijn!",
        cardContent2: "Enkele van onze topgerechten, en de gerechten die onze gasten het meest waarderen, zijn salades met worst uit de vallei, cannelloni, paella, kalfsgebraad en kabeljauw.",
        sliderControlsAboveAlt2: "Restaurant Hotel Camprodon",
        cardTitle2: "Het restaurant",
        cardContent3: "Het restaurant bevindt zich in een van de historische zalen van Hotel Camprodon en biedt plaats aan maximaal 140 personen. Het hotel heeft ook een tweede eetzaal voor maximaal 250 personen.",
        cardContent4: "In de lente en zomer kun je op het terras eten, met een prachtig uitzicht op de Pont Nou en de rivier de Ter.",
        formFormValue: "nl",
        checkboxHref: "/nl/privacy-beleid",
        sectionHeadSubtitle: "Fotogalerij",
        sectionHeadTitle: "Ontdek de modernistische stijl van ons restaurant",
        sectionHeadTexts: "Hieronder zie je een fotogalerij van ons restaurant, met traditionele, huisgemaakte en lokale gerechten.",
        galleryItemAlt: "Restaurant Hotel Camprodon",
        galleryItemAlt2: "Restaurant Hotel Camprodon",
        galleryItemAlt3: "Restaurant Hotel Camprodon",
        galleryItemAlt4: "Restaurant Hotel Camprodon",
        galleryItemAlt5: "Restaurant Hotel Camprodon",
    },
    cs: {
        heroImageAlt: "Restaurace hotelu Hotel Camprodon",
        heroSmallTitle: "Vychutnejte si tradiční kuchyni z místních surovin",
        heroTitle: "Restaurace hotelu Hotel Camprodon",
        presentationSmallTitle: "Tradiční kuchyně z místních surovin",
        presentationTitle: "Restaurace Hotel Camprodon",
        presentationContent: <>{"Restaurace hotelu Hotel Camprodon nabízí "}<strong>domácí a tradiční katalánskou kuchyni</strong>. Pracujeme především s místními surovinami z údolí Camprodon a se sezónními produkty.</>,
        fullSliderImgAlt: "Restaurace Hotel Camprodon",
        fullSliderImgAlt2: "Restaurace Hotel Camprodon",
        fullSliderImgAlt3: "Restaurace Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurace Hotel Camprodon",
        cardTitle: "Gastronomické speciality",
        cardContent: "Nabízíme polední a večerní menu a zejména pro rodiny a nejmenší máme dětské menu, které si zamilují!",
        cardContent2: "Mezi naše hvězdná jídla, která naši hosté nejvíce oceňují, patří saláty s uzeninami z údolí, cannelloni, paella, telecí pečeně a treska.",
        sliderControlsAboveAlt2: "Restaurace Hotel Camprodon",
        cardTitle2: "Restaurace",
        cardContent3: "Restaurace se nachází v jednom z historických sálů hotelu Hotel Camprodon a má kapacitu až 140 osob. Hotel má také druhou jídelnu s kapacitou až 250 osob.",
        cardContent4: "Na jaře a v létě můžete obědvat na terase s výjimečným výhledem na most Pont Nou a řeku Ter.",
        formFormValue: "cs",
        checkboxHref: "/cs/zasady-ochrany-soukromí",
        sectionHeadSubtitle: "Fotogalerie",
        sectionHeadTitle: "Objevte secesní styl naší restaurace",
        sectionHeadTexts: "Níže vám ukazujeme galerii fotografií naší restaurace s tradiční domácí kuchyní z místních surovin.",
        galleryItemAlt: "Restaurace Hotel Camprodon",
        galleryItemAlt2: "Restaurace Hotel Camprodon",
        galleryItemAlt3: "Restaurace Hotel Camprodon",
        galleryItemAlt4: "Restaurace Hotel Camprodon",
        galleryItemAlt5: "Restaurace Hotel Camprodon",
    },
    ru: {
        heroImageAlt: "Ресторан Hotel Camprodon",
        heroSmallTitle: "Традиционная кухня из местных продуктов",
        heroTitle: "Ресторан Hotel Camprodon",
        presentationSmallTitle: "Традиционная кухня из местных продуктов",
        presentationTitle: "Ресторан Hotel Camprodon",
        presentationContent: <>{"Ресторан Hotel Camprodon предлагает "}<strong>домашнюю традиционную каталонскую кухню</strong>. Мы работаем в основном с местными продуктами из долины Кампродон и сезонными ингредиентами.</>,
        fullSliderImgAlt: "Ресторан Hotel Camprodon",
        fullSliderImgAlt2: "Ресторан Hotel Camprodon",
        fullSliderImgAlt3: "Ресторан Hotel Camprodon",
        sliderControlsAboveAlt: "Ресторан Hotel Camprodon",
        cardTitle: "Гастрономические специалитеты",
        cardContent: "Мы предлагаем меню на обед и ужин, а специально для семей и детей у нас есть детское меню, которое им понравится!",
        cardContent2: "Среди наших фирменных блюд, которые больше всего ценят гости, — салаты с колбасами из долины, каннеллони, паэлья, жаркое из телятины и треска.",
        sliderControlsAboveAlt2: "Ресторан Hotel Camprodon",
        cardTitle2: "Ресторан",
        cardContent3: "Ресторан расположен в одном из парадных залов Hotel Camprodon и вмещает до 140 человек. В отеле есть и второй обеденный зал вместимостью до 250 человек.",
        cardContent4: "Весной и летом можно обедать на террасе с прекрасным видом на мост Понт-Ноу и реку Тер.",
        formFormValue: "ru",
        checkboxHref: "/ru/politika-otmeny",
        sectionHeadSubtitle: "Фотогалерея",
        sectionHeadTitle: "Стиль модерн нашего ресторана",
        sectionHeadTexts: "Ниже — галерея фотографий нашего ресторана с традиционной домашней кухней из местных продуктов.",
        galleryItemAlt: "Ресторан Hotel Camprodon",
        galleryItemAlt2: "Ресторан Hotel Camprodon",
        galleryItemAlt3: "Ресторан Hotel Camprodon",
        galleryItemAlt4: "Ресторан Hotel Camprodon",
        galleryItemAlt5: "Ресторан Hotel Camprodon",
    },
    sv: {
        heroImageAlt: "Restaurang på Hotel Camprodon",
        heroSmallTitle: "Njut av traditionell och lokal mat",
        heroTitle: "Restaurang på Hotel Camprodon",
        presentationSmallTitle: "Traditionell och lokal mat",
        presentationTitle: "Restaurang Hotel Camprodon",
        presentationContent: <>{"Restaurangen på Hotel Camprodon erbjuder "}<strong>hemlagad och traditionell katalansk mat</strong>. Vi arbetar främst med lokala råvaror från Camprodondalen och säsongens produkter.</>,
        fullSliderImgAlt: "Restaurang Hotel Camprodon",
        fullSliderImgAlt2: "Restaurang Hotel Camprodon",
        fullSliderImgAlt3: "Restaurang Hotel Camprodon",
        sliderControlsAboveAlt: "Restaurang Hotel Camprodon",
        cardTitle: "Gastronomiska specialiteter",
        cardContent: "Vi erbjuder lunch- och middagsmenyer, och särskilt för familjer och de minsta har vi en barnmeny som de kommer att älska!",
        cardContent2: "Några av våra stjärnrätter, och de som våra gäster uppskattar mest, är sallader med korv från dalen, canneloni, paella, kalvstek och torsk.",
        sliderControlsAboveAlt2: "Restaurang Hotel Camprodon",
        cardTitle2: "Restaurangen",
        cardContent3: "Restaurangen ligger i en av de historiska salongerna på Hotel Camprodon och har plats för upp till 140 personer. Hotellet har även en andra matsal med plats för upp till 250 personer.",
        cardContent4: "På våren och sommaren kan du äta på terrassen med fantastisk utsikt över Pont Nou och floden Ter.",
        formFormValue: "sv",
        checkboxHref: "/sv/privacy-policy",
        sectionHeadSubtitle: "Bildgalleri",
        sectionHeadTitle: "Upptäck vår restaurangs modernistiska stil",
        sectionHeadTexts: "Här är ett bildgalleri från vår restaurang, där du hittar traditionell, hemlagad och lokal mat.",
        galleryItemAlt: "Restaurang Hotel Camprodon",
        galleryItemAlt2: "Restaurang Hotel Camprodon",
        galleryItemAlt3: "Restaurang Hotel Camprodon",
        galleryItemAlt4: "Restaurang Hotel Camprodon",
        galleryItemAlt5: "Restaurang Hotel Camprodon",
    },
};

export default textos;
